// Who authored the skill. User skills are saved on the account. Paxton skills ship with the product.
export enum SkillOrigin {
  User = 'user',
  Paxton = 'paxton',
}

// Where Download as .md was chosen. The skills list is the modal. The open skill is the viewer.
export enum SkillDownloadSurface {
  Modal = 'modal',
  Viewer = 'viewer',
}
